module.exports = __webpack_public_path__ + "static/media/burge.7055faf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/burge.png
// module id = 85
// module chunks = 0